import { Text, type ComboboxItem } from '@mantine/core';
import { formatOrgName } from '@/lib/format';

/** Опция выпадающего списка базисов: label для строки ввода, title/address — для рендера. */
export interface BasisComboboxItem extends ComboboxItem {
  readonly title?: string;
  readonly address?: string;
}

// Единый рендер опции базиса в Select: НАЗВАНИЕ жирным, адрес — обычным серым.
// В строке выбранного значения остаётся label («Название — адрес») — там жирность не нужна.
export function renderBasisOption({ option }: { option: ComboboxItem }) {
  const item = option as BasisComboboxItem;
  if (!item.title) {
    return <Text size="sm">{option.label}</Text>;
  }
  return (
    <Text size="sm" lineClamp={2}>
      <Text component="span" fw={600} size="sm">
        {formatOrgName(item.title)}
      </Text>
      {item.address ? (
        <Text component="span" c="gray.7" size="sm">
          {' — '}
          {item.address}
        </Text>
      ) : null}
    </Text>
  );
}
